import {
	AppToolsScreen,
	ATS_CollectionUpgrades,
	ATS_TextArea,
	ComponentSync,
	ModuleFE_SyncManager_CSV,
	TS_AppTools,
	TS_Route
} from '@nu-art/thunderstorm-frontend/index';
import {Outlet} from 'react-router';
import {ATS_ButtonGroup, ATS_DropDown, ATS_Icons, ATS_Input, ATS_ScrollBar, ATS_ScrollFade} from '@app/styles';
import {ATS_AdvisorErrorBoundary, ATS_AdvisorPanel, ATS_DataFieldV2, ATS_Page_Advisor} from '@app/advisor-v5-frontend/ats';
import {ATS_Button} from '@app/styles/frontend/ui/components/Button/ATS_Button';
import {ATS_Toggle} from '@nu-art/thunderstorm-frontend/components/TS_Toggle/index';
import {ATS_ZippedCSV} from '@app/artifact-ats-frontend/ats/ATS_ZippedCSV/index';

const appToolsScreens: AppToolsScreen[] = [
	ATS_ScrollBar.Screen,
	ATS_Input.Screen,
	ATS_Icons.Screen,
	ATS_DropDown.Screen,
	ATS_ScrollFade.Screen,
	ATS_AdvisorPanel.Screen,
	ATS_Button.Screen,
	ATS_ButtonGroup.Screen,
	ATS_Page_Advisor.Screen,
	ATS_DataFieldV2.Screen,
	ATS_AdvisorErrorBoundary.Screen,
	ATS_TextArea.Screen,
	ATS_CollectionUpgrades.screen,
	ATS_Toggle.Screen,
	ATS_ZippedCSV.screen,
];

export class DevPage
	extends ComponentSync {

	static Route: TS_Route = {
		key: 'app-tools-wrapper',
		path: 'dev',
		children: [{
			...TS_AppTools.createRoute(appToolsScreens, 'app-tools'),
			index: true,
		}],
		Component: this,
	};

	componentDidMount() {
		//HACK HACK HACK - ready modules so we can use them in app tools screens!
		ModuleFE_SyncManager_CSV.readyAllModules();
	}

	render() {
		return <Outlet/>;
	}
}